import { useState, useEffect } from "react";
import { wsClient } from "../../api/ws.js";

export function ConnectionStatus() {
  const [status, setStatus] = useState<"connected" | "reconnecting" | "disconnected">(
    wsClient.getConnectionState(),
  );

  useEffect(() => {
    const unsub = wsClient.onStatusChange(setStatus);
    return unsub;
  }, []);

  const color =
    status === "connected"
      ? "bg-brand-green"
      : status === "reconnecting"
        ? "bg-status-paused"
        : "bg-status-error";

  const label =
    status === "connected"
      ? "Connected"
      : status === "reconnecting"
        ? "Reconnecting..."
        : "Disconnected";

  return (
    <div
      className={`w-2 h-2 rounded-full ${color} transition-colors duration-300`}
      title={`WebSocket: ${label}`}
    />
  );
}
